import { isEmpty } from 'lodash';
import { CHART_NAME } from '../../../../utils/constants.js';
import {
   RECOMMENDATION_STATUS_KEYS,
   generateDatesBetween,
   getFromToDate,
} from '../charts-util.js';
import { getStructuralConfigColumnsForRecommStatus } from './grid-recommendation-structural-utils.js';

export const getCompetitiveChangesFareChartStructuralConfig = (
   recommendationStatus,
   reasonsDropdownData,
   datesInSequence,
   filterBy,
   percentAbsolute,
   posOnClickHandler
) => {
   const isAnalystStatusView =
      RECOMMENDATION_STATUS_KEYS.APPROVAL_STATUS === recommendationStatus;

   return {
      chartKey: `${CHART_NAME.CHART_STRUCTURAL}-${CHART_NAME.CHART_COMPETITIVE_CHANGE_FARE}-${recommendationStatus}`,
      tableClassName: `competitive-changes-fare-structural${
         isAnalystStatusView ? ' approval-status-view' : ''
      }`,
      isVerticalHeader: !isAnalystStatusView,
      configTree: {
         isSubRows: true,
         childKey: 'subRows',
      },
      configColumns: getStructuralConfigColumnsForRecommStatus(
         recommendationStatus,
         reasonsDropdownData,
         isEmpty(filterBy)
            ? datesInSequence
            : generateDatesBetween(getFromToDate(filterBy), true),
         percentAbsolute,
         posOnClickHandler
      ),
      cssClasses: {
         tooltipCss: `competitive-changes-fare-structural-tooltip${
            isAnalystStatusView ? ' approval-status-view-tooltip' : ''
         }`,
      },
   };
};
